/* eslint-disable */
import * as React from "react"

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = (props: React.ComponentProps<"textarea">) => (
  <textarea {...props} />
)
Textarea.displayName = "Textarea"

export { Textarea }
